var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEpicFilterIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.785156 0.917527C0.785156 0.587741 1.02301 0.320312 1.31551 0.320312H7.68237C7.97487 0.320312 8.21273 0.587741 8.21273 0.917527V6.21917C8.21273 6.44546 8.09894 6.65181 7.91958 6.75274L4.49894 8.67746L1.07894 6.75338C0.898942 6.65181 0.785156 6.44481 0.785156 6.21981V0.917527Z",
    stroke: "#5FBDD1",
    strokeWidth: 0.55,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.39462 4.62867H3.6049V1.64453H5.39526M3.60426 3.13596H5.39462M3.30469 6.07832L4.49912 6.67553L5.6929 6.07832",
    stroke: "#5FBDD1",
    strokeWidth: 0.55,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpicFilterIcon);
export default __webpack_public_path__ + "static/media/epic_filter_icon.83ec3ba0632a2291e246d06e9dea0987.svg";
export { ForwardRef as ReactComponent };